import { render, staticRenderFns } from "./sourced-candidates-widget.vue?vue&type=template&id=5784c2c6&"
import script from "./sourced-candidates-widget.vue?vue&type=script&lang=js&"
export * from "./sourced-candidates-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports